import {
  COMENZAR_EDICION_PEDIDORUTA,
  PEDIDORUTA_EDITADO_EXITO,
  PEDIDORUTA_EDITADO_ERROR,
  RESET_EDICION_PEDIDORUTA,
} from "../types";

// cada reducer tiene su propio state
const initialState = {
  error: false,
  errorMessage: null,
  loading: false,
  data: null,
};

function pedidoRutaReducer(state = initialState, action) {
  switch (action.type) {
    case COMENZAR_EDICION_PEDIDORUTA:
      return {
        ...state,
        loading: action.payload,
        data: null,
      };
    case PEDIDORUTA_EDITADO_EXITO:
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        data: action.payload,
      };
    case PEDIDORUTA_EDITADO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errorMessage: action.payload.message,
        data: null,
      };
    case RESET_EDICION_PEDIDORUTA:
      return initialState;
    default:
      return state;
  }
}

export default pedidoRutaReducer;
